import { render, staticRenderFns } from "./user-promote.vue?vue&type=template&id=1689e1f6&scoped=true"
import script from "./user-promote.vue?vue&type=script&lang=js"
export * from "./user-promote.vue?vue&type=script&lang=js"
import style0 from "./user-promote.vue?vue&type=style&index=0&id=1689e1f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1689e1f6",
  null
  
)

export default component.exports